import currency from "currency.js";

/**
 * Return price from JSON provided, the logic for price lookup was provided in TS file by company
 */
export default class PriceCalculator {

    constructor( priceJSON )
    {
        this.units = {
            cattle: 0,
            sheep: 0,
        }
        this.priceJSON = priceJSON
        this.planPeriod = 'Monthly'
    }


    setUnits(unitObject)
    {
        this.units = unitObject
    }

  /**
   * Formula to get DSE number
   * @returns {number}
   */
    getDSENumber()
    {
        return (this.units.cattle * 8) + (this.units.sheep * 1.5)
    }

  /**
   * Format the price from cents to bigger units and get rid of trailing zeros if full number ( 123.00 -> 123 )
   * @param price
   * @returns {string}
   */
    formatPrice( price )
    {
        return currency(price, { symbol: "", fromCents: true }).format().replace(/\.0+$/,'')
    }

    getPrice(region, plan, planPeriod, saleDiscountPercentage)
    {
        this.planPeriod = planPeriod

        const price = this.priceJSON[region][plan][this.planPeriod].find((step) => this.getDSENumber() <= step.unitCap).price;

        if ( saleDiscountPercentage && saleDiscountPercentage > 0 ) {
            return this.formatPrice(price - (price * saleDiscountPercentage / 100))
        }

        return this.formatPrice(price)
    }
}



